import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { Field } from "@app/shared/models/form-field.model";

export interface DocumentWizard {
  companyId: Field;
  indexKey: Field;
  indexedDocumentList?: DocumentWizardList[];
}

export interface DocumentWizardList {
  receivedDate: string | Date;
  documentDescription: string;
  documentType: string;
  pages: number;
  documentNumber: string;
  isSelected?: boolean;
}

export interface DocumentWizardDocument {
  documentId: string;
  file: string;
}

export class DocumentsPlusDocWizAdapter extends AbstractAdapter<DocumentWizardDocument> {
  adapt(rawData: DocumentWizardDocument) {
    return rawData;
  }
}

/**
 * Data adapter for In Basket view document
 */
export class DocumentsPlusDocWizListAdapter extends AbstractAdapter<DocumentWizard> {
  adapt(rawData: DocumentWizard) {
    rawData?.indexedDocumentList.map((x) => {
      x.receivedDate = this.dateService.isValidDate(x.receivedDate as Date)
        ? this.dateService.stringToDate(x.receivedDate as string)
        : "";
      return x;
    });
    return rawData;
  }
}
